import { render, staticRenderFns } from "./infoWrapper.vue?vue&type=template&id=e1e4d7fe&scoped=true&"
import script from "./infoWrapper.vue?vue&type=script&lang=js&"
export * from "./infoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./infoWrapper.vue?vue&type=style&index=0&id=e1e4d7fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e4d7fe",
  null
  
)

export default component.exports